import React from "react";
import Row from "../../common/layout/row";
import Grid from "../../common/layout/grid";
import DateFormat from "../../common/dateFormat/DateFormat";

const estiloBotao = (desabilitado) => ({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontSize: "1.5rem",
    fontWeight: 500,
    boxShadow: desabilitado ? "inset 0 0 16px 1px #ccc" : "0 0 10px 1px #ccc",
    color: "#0070cc",
    width: 40,
    height: 40,
    borderRadius: "100%",
    backgroundColor: "#fff",
    border: "none",
    marginInline: 20,
});

export default function FiltroGraficoDia({ dataInicialGrafico, dataFinalGrafico, setDataInicialGrafico, setDataFinalGrafico, aguardando, mensagem }) {
    const mudarData = (data, dias, setData) => {
        const novaData = new Date(data);
        novaData.setUTCDate(novaData.getUTCDate() + dias);
        setData(novaData.toISOString().substring(0, 10));
    };
    const hoje = DateFormat.getDataAtual().replace(/\//g, "-");
    return (
        <Row style={{ width: "100%", justifyContent: "center" }}>
            <Grid cols="12 12 12 12" style={{ textAlign: "center", color: "#d42243" }}>
                {mensagem}
            </Grid>
            <Grid cols="12 12 4 4" style={{ display: "flex", minWidth: "fit-content", justifyContent: "center", alignItems: "center" }}>
                <button style={estiloBotao(false)} disabled={aguardando} onClick={() => mudarData(dataInicialGrafico, -1, setDataInicialGrafico)}>
                    &lt;
                </button>
                <input
                    style={{ fontSize: "1.2rem", padding: 7, border: "1px solid #999", borderRadius: 10 }}
                    required
                    type="date"
                    disabled={aguardando}
                    value={dataInicialGrafico}
                    max={dataFinalGrafico}
                    onChange={(e) => setDataInicialGrafico(e.target.value || dataFinalGrafico)}
                />
                <button
                    style={estiloBotao(dataInicialGrafico === dataFinalGrafico)}
                    disabled={dataInicialGrafico === dataFinalGrafico || aguardando}
                    onClick={() => mudarData(dataInicialGrafico, 1, setDataInicialGrafico)}
                >
                    &gt;
                </button>
            </Grid>
            <div style={{ display: "flex", minWidth: "fit-content", justifyContent: "center", alignItems: "center", fontSize: "1.2rem", padding: 15 }}>Até</div>
            <Grid cols="12 12 4 4" style={{ display: "flex", minWidth: "fit-content", justifyContent: "center", alignItems: "center" }}>
                <button
                    style={estiloBotao(dataInicialGrafico === dataFinalGrafico)}
                    disabled={dataInicialGrafico === dataFinalGrafico || aguardando}
                    onClick={() => mudarData(dataFinalGrafico, -1, setDataFinalGrafico)}
                >
                    &lt;
                </button>
                <input
                    style={{ fontSize: "1.2rem", padding: 7, border: "1px solid #999", borderRadius: 10 }}
                    required
                    type="date"
                    disabled={aguardando}
                    value={dataFinalGrafico}
                    min={dataInicialGrafico}
                    max={hoje}
                    onChange={(e) => setDataFinalGrafico(e.target.value || hoje)}
                />
                <button
                    style={estiloBotao(dataFinalGrafico === hoje)}
                    disabled={dataFinalGrafico === hoje || aguardando}
                    onClick={() => mudarData(dataFinalGrafico, 1, setDataFinalGrafico)}
                >
                    &gt;
                </button>
            </Grid>
        </Row>
    );
}
